import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { BASE_SP_V2_PROGRESS_PATH } from "../constants"
import { getServiceErrorMessage } from "../../helpers"
import { Context, Transitions } from "../../types"
import { StudyPlanProgressModel } from "../../../../../../types/gqlTypes/graphql"

export const getProgressByStudyPlanSubjectsTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getProgressByStudyPlanSubjects",
    src: "getProgressByStudyPlanSubjects",
    onDone: {
      target: `${BASE_SP_V2_PROGRESS_PATH}.idle`,
      actions: assign<
        Context,
        DoneInvokeEvent<Record<string, StudyPlanProgressModel>>
      >((_ctx, evt) => {
        return {
          progressBySubjectsModel: evt.data
        }
      })
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        loading: false,
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("getProgressByStudyPlanSubjects", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
